import { rem, styled } from 'design-system';

export const ButtonGroup = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: rem(16),
});
